import React, { useEffect, useState } from "react";
import { jobsApi } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Briefcase, MapPin, CheckCircle2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function CandidatePortal() {
  const { user } = useAuth();
  const [jobs, setJobs] = useState([]);
  const [applied, setApplied] = useState(new Set());
  useEffect(() => { jobsApi.list().then(setJobs); }, []);
  const apply = (id) => {
    setApplied(new Set([...applied, id]));
    toast.success("Application submitted — a recruiter will reach out");
  };
  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-1">Candidate Portal</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Hi {user?.name?.split(" ")[0]} — your next role awaits.</h1>
      </div>
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
        {jobs.map((j) => (
          <Card key={j.id} className="border-border shadow-none p-5">
            <div className="flex items-start justify-between">
              <div className="h-10 w-10 rounded-md bg-[#0047AB]/10 text-[#0047AB] grid place-items-center"><Briefcase className="h-5 w-5" /></div>
              <Badge variant="outline" className="text-[10px] font-mono uppercase tracking-wider">{j.employment_type}</Badge>
            </div>
            <h3 className="font-display font-bold text-lg tracking-tight mt-4">{j.title}</h3>
            <div className="text-sm text-muted-foreground">{j.client}</div>
            <div className="mt-2 flex items-center gap-2 text-xs text-muted-foreground">
              <MapPin className="h-3 w-3" /> {j.location}
            </div>
            <div className="mt-3 flex flex-wrap gap-1.5">
              {j.skills.slice(0, 4).map((s) => <Badge key={s} variant="secondary" className="text-[10px] font-mono">{s}</Badge>)}
            </div>
            <div className="mt-4 pt-4 border-t border-border flex items-center justify-between">
              <span className="font-mono text-sm">${(j.salary_min / 1000).toFixed(0)}k–${(j.salary_max / 1000).toFixed(0)}k</span>
              {applied.has(j.id) ? (
                <Badge className="bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-50"><CheckCircle2 className="h-3 w-3 mr-1" /> Applied</Badge>
              ) : (
                <Button size="sm" onClick={() => apply(j.id)} className="bg-[#0047AB] hover:bg-[#003380]">Apply</Button>
              )}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
